export const APP_VERSION = '1.1.0';
export const BUILD_DATE = new Date().toISOString();

export function getAppVersion(): string {
  return APP_VERSION;
}

export function getBuildDate(): string {
  return BUILD_DATE;
}

export function checkForUpdates(): boolean {
  const storedVersion = localStorage.getItem('app_version');

  if (!storedVersion) {
    localStorage.setItem('app_version', APP_VERSION);
    return false;
  }

  if (storedVersion !== APP_VERSION) {
    return true;
  }

  return false;
}

export function updateStoredVersion(): void {
  localStorage.setItem('app_version', APP_VERSION);
}

export function clearVersionCache(): void {
  localStorage.removeItem('app_version');
}
